module.exports = __webpack_public_path__ + "static/media/chat-bubbles-with-ellipsis.ee77759d.svg";